import Api from "@/services/api";
import qs from "querystring";

export default {
  get(id) {
    return Api().get("/settlement/" + id);
  },
  delete(id) {
    return Api().delete("/settlement/" + id);
  },
  rompre(id) {
    return Api().get("/settlement/" + id + "/breach");
  },
  readjust(id) {
    return Api().get("/settlement/" + id + "/readjust");
  },
  readjust_manual(id, index, date) {
    return Api().get(
      "/settlement/" +
        id +
        "/readjust/" +
        encodeURIComponent(index + ":" + date)
    );
  },
  new(id) {
    return Api().get("/warrant/" + id + "/settlement/new");
  },
  post(data) {
    return Api().post("/settlement", qs.stringify({ data: data }));
  },
  search(
    params,
    filters = [],
    hiddenFilter = "",
    page = 1,
    sortBy = "date",
    sortDesc = false,
    fetchFacets = true,
    parameters = []
  ) {
    return Api().post(
      "/settlements/search-settlements",
      qs.stringify({
        search: JSON.stringify(params),
        filters: JSON.stringify(filters),
        hiddenFilter: hiddenFilter,
        page: page,
        sortBy: sortBy,
        sortDesc: sortDesc,
        fetchFacets: fetchFacets,
        warrant_id: parameters.warrant_id
      })
    );
  },
};
